import { createRouter, createWebHistory } from "vue-router";

import LineLogin from "@/module/LineLogin/page/LineLogin.vue"
import Notfound from "@/module/Static/Notfound/page/Notfound.vue";
import NotRegister from "@/module/NotRegister/page/NotRegister.vue";
import Privilege from '@/module/List/page/Privilege.vue';
import Help from "@/module/Help/page/Help.vue";
import CampaignDetail from "@/module/Detail/page/Campaign.vue"
import History from "@/module/History/page/History.vue";
import PolicyListing from "@/module/PolicyListing/page/PolicyListing.vue"
import PolicyDetail from "@/module/PolicyListing/page/PolicyDetail.vue"

// dealer
import DealerSearch from "@/module/Search/page/SearchPage.vue"
import DealerList from "@/module/Search/page/DealerListPage.vue"
import DealerDetail from "@/module/Search/page/DealerDetailPage.vue"
import DealerMaps from "@/module/Maps/page/MapsPage.vue"

// renewal & claim
import Renewal from "@/module/Renewal/page/RenewalPage.vue"
import AppointmentClaim from "@/module/Appointment/page/AppointmentClaimPage.vue"
import ClaimWithoutRegister from "@/module/Appointment/page/ClaimWithoutRegister.vue"
import ClaimAlreadyRegistered from "@/module/Appointment/page/ClaimAlreadyRegistered.vue"
import ClaimHistory from "@/module/History/page/ClaimHistoryPage.vue"

import ProfilePage from "@/module/Profile/page/ProfilePage.vue"
import EDocumentPage from "@/module/EDocument/page/EDocumentPage.vue"

// standard register
import StarndardRegisterPage from "@/module/StarndardRegister/page/StarndardRegisterPage.vue"
import StarndardRegisterFormPage from "@/module/StarndardRegister/page/StarndardRegisterFormPage.vue"
import StarndardRegisterSuccessPage from "@/module/StarndardRegister/page/StarndardRegisterSuccessPage.vue"

// register
import RegisterConsent from "@/module/Register/page/RegisterConsent.vue"
import Register from "@/module/Register/page/Register.vue"
import RegisterSuccess from "@/module/Register/component/TtbRegister/TtbRegisterSuccess.vue"
import SmsRegister from "@/module/Register/page/SmsRegister.vue"
import LonRegister from "@/module/Register/page/LonRegister.vue"

//NewRegister
import NewRegisterPage from "@/module/StarndardRegister/page/NewRegisterPage.vue"
import NewRegisterPageFormPage from "@/module/StarndardRegister/page/NewRegisterFormPage.vue"
import NewRegisterPageSuccessPage from "@/module/StarndardRegister/page/NewRegisterSuccessPage.vue"

import RegisterErrorPage from "@/module/StarndardRegister/page/RegisterErrorPage.vue"

//sent text
import SendText from "@/module/SentText/page/SendText.vue"

// page
import OpenExternal from '@/module/LineLogin/page/OpenExternal.vue';

const routes = [
    {
        path: "/",
        name: "default",
        component: Privilege
    },
    {
        path: '/privilege',
        name: 'privilege',
        component: Privilege
    },
    {
        path: '/privilege/:catId',
        name: 'category',
        component: Privilege
    },
    {
        path: "/notregister",
        name: "notRegister",
        component: NotRegister
    },
    {
        path: "/help",
        name: "help",
        component: Help
    },
    {
        path: "/edocument",
        name: "edocument",
        component: EDocumentPage
    },
    {
        path: "/registerstandard/consent",
        name: "starndardregisterconsent",
        component: StarndardRegisterPage
    },
    {
        path: "/registerstandard/form",
        name: "starndardregisterform",
        component: StarndardRegisterFormPage
    },
    {
        path: "/registerstandard/success",
        name: "starndardregistersuccess",
        component: StarndardRegisterSuccessPage
    },
    {
        path: "/profile",
        name: "profile",
        component: ProfilePage
    },
    {
        path: "/policylisting",
        name: "policylisting",
        component: PolicyListing
    },
    {
        path: "/policydetail/:id?",
        name: "policydetail",
        component: PolicyDetail
    },
    {
        path: "/campaign/:campaignId",
        name: "campaign",
        component: CampaignDetail
    },
    {
        path: "/Dealers.aspx",
        name: "dealers_aspx",
        component: DealerSearch
    },
    {
        path: "/dealer/search",
        name: "dealer_search",
        component: DealerSearch
    },
    {
        path: "/dealer/list",
        name: "dealer_list",
        component: DealerList
    },
    {
        path: "/campaign/:campaignId",
        name: "campaign",
        component: CampaignDetail
    },
    {
        path: "/dealer/detail",
        name: "dealer_detail",
        component: DealerDetail
    },
    {
        path: "/dealer/maps",
        name: "dealer_maps",
        component: DealerMaps
    },
    {
        path: "/renewal/:channel?",
        name: "renewal",
        component: Renewal
    },
    {
        path: '/appointment/claim/:policyNo',
        name: 'appointment_claim',
        component: AppointmentClaim
    },
    {
        path: '/claim-no-register',
        name: 'claim_no_register',
        component: ClaimWithoutRegister
    },
    {
        path: '/claim-already-registered',
        name: 'claim_already_registered',
        component: ClaimAlreadyRegistered
    },
    {
        path: "/linelogin",
        name: "linelogin",
        component: LineLogin
    },
    {
        path: "/history/:tab?",
        name: "history",
        component: History
    },
    {
        path: "/claim",
        name: "claim_history",
        component: ClaimHistory
    },
    {
        path: "/ttb-register-consent",
        name: "register_ttb_consent",
        component: RegisterConsent
    },
    {
        path: "/ttb-register",
        name: "register_ttb",
        component: Register
    },
    {
        path: "/ttb-register-success",
        name: "register_ttb_success",
        component: RegisterSuccess
    },
    {
        path: "/sms-register",
        name: "register_sms",
        component: SmsRegister
    },
    {
        path: "/lon-register",
        name: "register_lon",
        component: LonRegister
    },
    {
        path: '/openweb/:path?',
        name: 'openweb',
        component: OpenExternal,
    },
    {
        path: "/newregister",
        name: "newregister",
        component: NewRegisterPage
    },
    {
        path: "/newregister/form",
        name: "newregisterform",
        component: NewRegisterPageFormPage
    },
    {
        path: "/newregister/success",
        name: "newregistersuccess",
        component: NewRegisterPageSuccessPage
    },
    {
        path: "/register/error",
        name: "RegisterError",
        component: RegisterErrorPage
    },
    {
        path: "/sendtext",
        name: "sendtext",
        component: SendText
    },
    {
        path: "/:catchAll(.*)",
        component: Notfound
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior: () => {
        return {
            top: 0
        }
    }
});

export default router;
